const Help = () => {
    return(
        <div>We are here to help you</div>
    )
}

export default Help